export default {
  check:
    'M7.55685,12.9497 L3.31421,8.70711 L1.9,10.1213 L7.55685,15.7782 L17.4563,5.87868 L16.0421,4.46447 Z',
  subcheck: 'M 4 9 L 4 11 L 16 11 L 16 9 Z',
};
